import React, { PureComponent } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import esLocale from 'moment/locale/es';
import moment from 'moment';

class DatePicker extends PureComponent {
  constructor(props) {
    super(props);
    moment.locale('es', esLocale);
  }

  state = {
    focused: false,
  };

  onFocusChange = value => {
    this.setState({ focused: !this.state.focused });
    const { input } = this.props;
    input.onFocus(value);
  };

  render() {

    const {
      input,
      meta: { touched, error, warning },
      placeholder,
      disabled,
      required,
      label,
    } = this.props;
    const { focused } = this.state;
    const invalid = error !== undefined && error !== null;
    const className = `field ${error && touched ? 'error' : ''}`;
    const classNameInput = `ui input ${required ? 'required' : ''}`;

    return (
      <div className={className}>
        <label> {label} </label>
        <div className={classNameInput}>
          <SingleDatePicker
            showClearDate={true}
            showDefaultInputIcon={true}
            displayFormat="DD-MM-YYYY"
            numberOfMonths={1}
            disabled={disabled}
            placeholder={placeholder}
            date={input.value}
            onDateChange={input.onChange}
            focused={focused}
            onFocusChange={this.onFocusChange}
            id={input.name}
            isOutsideRange={() => false}
          />
          
        </div>
        {error && touched && <span className="message-error">{error}</span>}
      </div >
    );
  }
}

export const formatDates = value => (value ? moment(value) : null);

export const normalizeDates = value =>
  value ? value.format('YYYY-MM-DD HH:mm') : null;

export default DatePicker;
